import React from "react";
import { Trans } from "@lingui/macro";

export const CommonMessages = {
  expiredLink: (
    <Trans id="common.expiredLink.message">Your link has expired, click here to resend.</Trans>
  ),
};
